import { render, staticRenderFns } from "./EditCoursePage.vue?vue&type=template&id=c3533c70&scoped=true&"
import script from "./EditCoursePage.vue?vue&type=script&lang=js&"
export * from "./EditCoursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3533c70",
  null
  
)

export default component.exports